<nav class="side-nav">

  <div class="side-nav-header">
    <span class="wordmark">flip*</span>
  </div>

  <div class="side-nav-items">

    <!-- Home -->
    <a class="nav-item"
       routerLink="/landing-page"
       (click)="trackNavItem('/landing-page', 'SideNavHomeClicked')"
       [class.active]="isHomeActive()"
       [style.--nav-accent]="'var(--color-skylight)'">
      <!-- Two fixed-src icons toggled via a CSS class (not [hidden] - _icons.scss sets a global
         svg-icon { display: flex }, which as an author style always beats the [hidden] UA default
         regardless of specificity) rather than swapping [src]: angular-svg-icon
           doesn't cancel an in-flight fetch when src changes again before it resolves, so
           whichever variant's request happens to resolve first wins and can stick permanently
           (visible on a fresh page load/refresh, where both requests fire close together). -->
      <svg-icon class="nav-icon home parchment" [class.icon-hidden]="!isHomeActive()" src="assets/nav/nav-home-selected.svg"></svg-icon>
      <svg-icon class="nav-icon home parchment" [class.icon-hidden]="isHomeActive()" src="assets/nav/nav-home-unselected.svg"></svg-icon>
      <span class="nav-label">Home</span>
    </a>

    <!-- Score (smart routing: /score or /score/marginofsafety) -->
    <div class="nav-item"
         [class.active]="isScoreActive()"
         [style.--nav-accent]="'var(--color-sundown)'"
         (click)="navigateScore()"
         role="button"
         tabindex="0"
         (keyup.enter)="navigateScore()">
      <svg-icon class="nav-icon score parchment" [class.icon-hidden]="!isScoreActive()" src="assets/nav/nav-score-selected.svg"></svg-icon>
      <svg-icon class="nav-icon score parchment" [class.icon-hidden]="isScoreActive()" src="assets/nav/nav-score-unselected.svg"></svg-icon>
      <span class="nav-label">Score</span>
    </div>

    <!-- Plan -->
    <a class="nav-item"
       routerLink="/plan-home"
       (click)="trackNavItem('/plan-home', 'SideNavPlanClicked')"
       [class.active]="isPlanActive()"
       [style.--nav-accent]="'var(--color-wisteria)'">
      <svg-icon class="nav-icon plan parchment" [class.icon-hidden]="!isPlanActive()" src="assets/nav/nav-plan-selected.svg"></svg-icon>
      <svg-icon class="nav-icon plan parchment" [class.icon-hidden]="isPlanActive()" src="assets/nav/nav-plan-unselected.svg"></svg-icon>
      <span class="nav-label">Plan</span>
    </a>

    <!-- Sanctuary -->
    <a class="nav-item"
       routerLink="/sanctuary"
       (click)="trackNavItem('/sanctuary', 'SideNavSanctuaryClicked')"
       [class.active]="isRouteActive('/sanctuary')"
       [style.--nav-accent]="'var(--color-sagebrush)'">
      <svg-icon class="nav-icon sanctuary parchment" [class.icon-hidden]="!isRouteActive('/sanctuary')" src="assets/nav/nav-sanctuary-selected.svg"></svg-icon>
      <svg-icon class="nav-icon sanctuary parchment" [class.icon-hidden]="isRouteActive('/sanctuary')" src="assets/nav/nav-sanctuary-unselected.svg"></svg-icon>
      <span class="nav-label">Sanctuary</span>
    </a>

    <!-- Learn -->
    <a class="nav-item"
       routerLink="/learn"
       (click)="trackNavItem('/learn', 'SideNavLearnClicked')"
       [class.active]="isRouteActive('/learn')"
       [style.--nav-accent]="'var(--color-camellia)'">
      <svg-icon class="nav-icon learn parchment" [class.icon-hidden]="!isRouteActive('/learn')" src="assets/nav/nav-learn-selected.svg"></svg-icon>
      <svg-icon class="nav-icon learn parchment" [class.icon-hidden]="isRouteActive('/learn')" src="assets/nav/nav-learn-unselected.svg"></svg-icon>
      <span class="nav-label">Learn</span>
    </a>

    <!-- Community -->
    <a class="nav-item"
       routerLink="/community"
       flipCoachTarget="community.desktop_navigation"
       (click)="trackNavItem('/community', 'SideNavCommunityClicked'); communityWelcome.onTargetUsed()"
       [class.active]="isRouteActive('/community')"
       [style.--nav-accent]="'var(--color-starlight)'">
      <svg-icon class="nav-icon community parchment" [class.icon-hidden]="!isRouteActive('/community')" src="assets/nav/nav-community-selected.svg"></svg-icon>
      <svg-icon class="nav-icon community parchment" [class.icon-hidden]="isRouteActive('/community')" src="assets/nav/nav-community-unselected.svg"></svg-icon>
      <span class="nav-label">Community</span>
    </a>

    <!-- Help (FLIP-325) -->
    <a class="nav-item"
       routerLink="/help"
       (click)="trackNavItem('/help', 'SideNavHelpClicked')"
       [class.active]="isRouteActive('/help')"
       [style.--nav-accent]="'var(--color-harbour)'">
      <svg-icon class="nav-icon help parchment" [class.icon-hidden]="!isRouteActive('/help')" src="assets/nav/nav-help-selected.svg"></svg-icon>
      <svg-icon class="nav-icon help parchment" [class.icon-hidden]="isRouteActive('/help')" src="assets/nav/nav-help-unselected.svg"></svg-icon>
      <span class="nav-label">Help</span>
    </a>

    <!-- Settings (side-nav only; single icon, no selected/unselected pair, CSS-only active state) -->
    <a class="nav-item settings"
       routerLink="/settings"
       (click)="trackNavItem('/settings', 'SideNavSettingsClicked')"
       [class.active]="isRouteActive('/settings')"
       [style.--nav-accent]="'var(--color-blossom)'">
      <svg-icon class="nav-icon parchment" src="assets/nav/nav-settings-unselected.svg"></svg-icon>
      <span class="nav-label">Settings</span>
    </a>

  </div>

  <div class="side-nav-footer">
    <img class="app-store-badge" src="assets/icons/icon-flip.png" alt="Download on the App Store" />
    <span class="app-version">app version: {{ version }}</span>
    <a class="privacy-link"
       href="https://legal.get-flipped.app/privacy-policy.html"
       rel="noopener noreferrer"
       (click)="openExternalLink($event, 'https://legal.get-flipped.app/privacy-policy.html')">Privacy Policy</a>
      <a class="terms-link"
       href="https://legal.get-flipped.app/terms-of-use.html"
       rel="noopener noreferrer"
       (click)="openExternalLink($event, 'https://legal.get-flipped.app/terms-of-use.html')">Terms of Use</a>
  </div>

</nav>
